<h1 class="fw-bold f-size-24 mb-5">პირადი ინფორმაცია</h1>

<!-- legal -->
<form *ngIf="userCanManageAuction" [formGroup]="form">
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable title="საიდენთიფიკაციო კოდი">
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.id_number }}
      </p>
    </app-custom-foldable>
  </div>

  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable title="დასახელება">
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.legal_title }}
      </p>
    </app-custom-foldable>
  </div>

  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="იურიდიული ფორმა"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.legal_form }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="legal_form"
          type="text"
          placeholder="იურიდიული ფორმა"
        ></app-text-input>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>

  <h2 class="fw-bold f-size-18 mt-5 mb-3">საკონტაქტო ინფორმცია</h2>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="ტელეფონი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.phone_number }}
      </p>
      <div body class="col-lg-6 px-0">
        <ng-select
          [items]="countriesList"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="country_id"
          class="mb-3"
          name="countryCode"
        >
          <ng-template
            *ngIf="form.get('country_id').value"
            ng-label-tmp
            let-item="item"
          >
            <div>ქვეყნის კოდი</div>
            {{ item.name }} (+{{ item.phone_code }})
          </ng-template>
          <ng-template
            *ngIf="!form.get('country_id').value"
            ng-label-tmp
            let-item="item"
          >
            ქვეყნის კოდი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }} ( + {{ item.phone_code }} )
          </ng-template>
        </ng-select>
        <app-text-input
          formControlName="phone_number"
          type="text"
          placeholder="ტელეფონის ნომერი"
        ></app-text-input>
        <p class="mb-0 mt-2 f-size-12">
          აირჩიეთ ერთ-ერთი, რომელზეც მოგივათ sms კოდი
        </p>
        <ng-select
          [items]="getMessageTypes"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="message_type"
          class="mb-3 ng-width-currency"
          name="message_type"
          [searchable]="false"
        >
          <ng-template
            *ngIf="form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            {{ item.display_name }}
          </ng-template>
          <ng-template
            *ngIf="!form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            ტიპი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.display_name }}
          </ng-template>
        </ng-select>
        <div class="d-flex justify-content-between w-100">
          <button
            class="btn btn-primary bg-vibrant-blue f-size-16 fw-SemiBold mb-3 py-3"
            [disabled]="oldSmsIsChecked"
            (click)="verifyOldCode('phone')"
          >
            კოდის გაგზავნა
          </button>
          <app-text-input
            *ngIf="oldEmailChecked"
            formControlName="old_email_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
            [floatingPlaceholder]="true"
          >
          </app-text-input>
          <app-text-input
            *ngIf="oldSmsIsChecked"
            formControlName="old_sms_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
            [floatingPlaceholder]="true"
          >
          </app-text-input>
        </div>

        <app-text-input
          *ngIf="codeWasSentForThisNumber"
          formControlName="sms_code"
          type="text"
          placeholder="ახალ ნომერზე გამოგზავნილი კოდი"
          [floatingPlaceholder]="true"
        >
        </app-text-input>
        <p *ngIf="smsIsChecked">ნომერი წარმატებით განახლდა</p>
      </div>
    </app-custom-foldable>
  </div>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="ელ-ფოსტა"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.email }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="email"
          type="text"
          placeholder="ელ-ფოსტა"
        ></app-text-input>
        <ng-select
          [items]="getMessageTypes"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="message_type"
          class="mb-3 ng-width-currency"
          name="message_type"
          [searchable]="false"
        >
          <ng-template
            *ngIf="form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            {{ item.display_name }}
          </ng-template>
          <ng-template
            *ngIf="!form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            ტიპი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.display_name }}
          </ng-template>
        </ng-select>
        <div class="d-flex justify-content-between">
          <button
            class="btn btn-primary bg-vibrant-blue f-size-16 fw-SemiBold mb-3 py-3"
            [disabled]="oldSmsIsChecked || oldEmailChecked"
            (click)="verifyOldCode('email')"
          >
            კოდის გაგზავნა
          </button>
          <app-text-input
            *ngIf="oldEmailChecked"
            formControlName="old_email_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
          <app-text-input
            *ngIf="oldSmsIsChecked"
            formControlName="old_sms_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
        </div>
        <app-text-input
          *ngIf="codeWasSentForThisEmail"
          formControlName="email_code"
          type="text"
          placeholder="ახალ ელ-ფოსტაზე გამოგზავნილი კოდი"
        >
        </app-text-input>
      </div>
    </app-custom-foldable>
  </div>

  <h2 class="fw-bold f-size-18 mt-5 mb-3">იურიდიული მისამართი</h2>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="ქვეყანა/ქალაქი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{
          (findUserCountry ? findUserCountry : "") +
            (findUserCity ? ", " + findUserCity : "")
        }}
      </p>
      <div body>
        <div class="col-lg-6 px-0 mb-3">
          <ng-select
            appFormErrorMsg
            [items]="countriesList"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            formControlName="country_id"
            name="countryCode"
            placeholder="ქვეყანა"
          >
            <ng-template
              *ngIf="form.get('country_id').value"
              ng-label-tmp
              let-item="item"
            >
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
        <div class="col-lg-6 px-0 mb-3">
          <ng-select
            appFormErrorMsg
            [items]="citiesList"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            formControlName="city_id"
            name="city_id"
            placeholder="ქალაქი"
          >
            <ng-template
              *ngIf="!form.get('city_id').value"
              ng-label-tmp
              let-item="item"
            >
              ქალაქი
            </ng-template>
            <ng-template
              *ngIf="form.get('city_id').value"
              ng-label-tmp
              let-item="item"
            >
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>

  <!-- <div class="border-bottom mb-3 pb-3">

    <app-custom-foldable (isDisableOutput)="isComponentDisabled($event)" (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true" [isDisabled]="getIsDisabled" [isComponentOpen]="isComponentOpen" title="ქალაქი">
      <p *ngIf="findUserCity.name" header class="f-size-18 mb-0 personal-information__word-break">
        {{ findUserCity.name }}
      </p>
      <div body class="col-lg-6 px-0">
        <ng-select [items]="citiesList" [clearable]="false" bindLabel="name" bindValue="id" formControlName="city_id"
          class="mb-3" name="city_id" placeholder="ქალაქი">
          <ng-template *ngIf="form.get('city_id').value" ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
      </div>
    </app-custom-foldable>
  </div> -->
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="იურიდიული მისამართი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.legal_address }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="legal_address"
          type="text"
          placeholder="იურიდიული მისამართი"
        >
        </app-text-input>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>

  <h2 class="fw-bold f-size-18 mt-5 mb-3">პასუხისმგებელი პირი</h2>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="სახელი გვარი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.first_name }} {{ getUserInformation.last_name }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="first_name"
          type="text"
          placeholder="სახელი"
        ></app-text-input>
        <app-text-input
          formControlName="last_name"
          type="text"
          placeholder="გვარი"
        ></app-text-input>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="პირადი ნომერი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.personal_number }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="personal_number"
          type="text"
          placeholder="პირადი ნომერი"
        ></app-text-input>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>
</form>

<!-- physical -->
<form *ngIf="!userCanManageAuction" [formGroup]="form">
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable title="პირადი ნომერი">
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.personal_number }}
      </p>
    </app-custom-foldable>
  </div>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="სახელი გვარი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.first_name }} {{ getUserInformation.last_name }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="first_name"
          type="text"
          placeholder="სახელი"
        ></app-text-input>
        <app-text-input
          formControlName="last_name"
          type="text"
          placeholder="გვარი"
        ></app-text-input>
        <button
          class="btn btn-primary fw-SemiBold f-size-16 p-2 bg-vibrant-blue"
          (click)="onSubmit()"
        >
          შენახვა
        </button>
      </div>
    </app-custom-foldable>
  </div>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="ტელეფონი"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.phone_number }}
      </p>
      <div body class="col-lg-6 px-0">
        <ng-select
          [items]="countriesList"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="phone_country_id"
          class="mb-3"
          name="countryCode"
        >
          <ng-template
            *ngIf="form.get('phone_country_id').value"
            ng-label-tmp
            let-item="item"
          >
            <div>ქვეყნის კოდი</div>
            {{ item.name }} (+{{ item.phone_code }})
          </ng-template>
          <ng-template
            *ngIf="!form.get('phone_country_id').value"
            ng-label-tmp
            let-item="item"
          >
            ქვეყნის კოდი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }} ( + {{ item.phone_code }} )
          </ng-template>
        </ng-select>
        <app-text-input
          formControlName="phone_number"
          type="text"
          placeholder="ტელეფონის ნომერი"
        ></app-text-input>
        <p class="mb-0 mt-2 f-size-12">
          აირჩიეთ ერთ-ერთი, რომელზეც მოგივათ sms კოდი
        </p>
        <ng-select
          [items]="getMessageTypes"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="message_type"
          class="mb-3 ng-width-currency"
          name="message_type"
          [searchable]="false"
        >
          <ng-template
            *ngIf="form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            {{ item.display_name }}
          </ng-template>
          <ng-template
            *ngIf="!form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            ტიპი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.display_name }}
          </ng-template>
        </ng-select>
        <div class="d-flex justify-content-between w-100">
          <button
            class="btn btn-primary bg-vibrant-blue f-size-16 fw-SemiBold mb-3 py-3"
            [disabled]="oldSmsIsChecked"
            (click)="verifyOldCode('phone')"
          >
            კოდის გაგზავნა
          </button>
          <app-text-input
            *ngIf="oldEmailChecked"
            formControlName="old_email_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
          <app-text-input
            *ngIf="oldSmsIsChecked"
            formControlName="old_sms_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
        </div>

        <app-text-input
          *ngIf="codeWasSentForThisNumber"
          formControlName="sms_code"
          type="text"
          placeholder="ახალ ნომერზე გამოგზავნილი კოდი"
        >
        </app-text-input>
        <p *ngIf="smsIsChecked">ნომერი წარმატებით განახლდა</p>
      </div>
    </app-custom-foldable>
  </div>
  <div class="border-bottom mb-3 pb-3">
    <app-custom-foldable
      (isDisableOutput)="isComponentDisabled($event)"
      (isComponentClosed)="isComponentClosed($event)"
      [changeable]="true"
      [isDisabled]="getIsDisabled"
      [isComponentOpen]="isComponentOpen"
      title="ელ-ფოსტა"
    >
      <p header class="f-size-18 mb-0 personal-information__word-break">
        {{ getUserInformation.email }}
      </p>
      <div body class="col-lg-6 px-0">
        <app-text-input
          formControlName="email"
          type="text"
          placeholder="ელ-ფოსტა"
        ></app-text-input>
        <ng-select
          [items]="getMessageTypes"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="message_type"
          class="mb-3 ng-width-currency"
          name="message_type"
          [searchable]="false"
        >
          <ng-template
            *ngIf="form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            {{ item.display_name }}
          </ng-template>
          <ng-template
            *ngIf="!form.get('message_type').value"
            label="message_type"
            ng-label-tmp
            let-item="item"
          >
            ტიპი
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.display_name }}
          </ng-template>
        </ng-select>
        <div class="d-flex justify-content-between">
          <button
            class="btn btn-primary bg-vibrant-blue f-size-16 fw-SemiBold mb-3 py-3"
            [disabled]="oldSmsIsChecked || oldEmailChecked"
            (click)="verifyOldCode('email')"
          >
            კოდის გაგზავნა
          </button>
          <app-text-input
            *ngIf="oldEmailChecked"
            formControlName="old_email_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
          <app-text-input
            *ngIf="oldSmsIsChecked"
            formControlName="old_sms_code"
            type="text"
            class="col-7 pr-0"
            placeholder="XXXX შეიყვანეთ კოდი"
          >
          </app-text-input>
        </div>
        <app-text-input
          *ngIf="codeWasSentForThisEmail"
          formControlName="email_code"
          type="text"
          placeholder="ახალ ელ-ფოსტაზე გამოგზავნილი კოდი"
        >
        </app-text-input>
      </div>
    </app-custom-foldable>
  </div>
</form>
